import { render } from "./Accordion.vue?vue&type=template&id=39444166&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=39444166&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39444166"]])

export default __exports__